import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationViewModel, PageElementViewModel, RegistrationPackageViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConferenceCMSService, OrganizationService, UserService } from 'src/app/_services/generatedServices';
import { PackagePurchaseModalComponent } from 'src/app/conferences/registration/package-purchase-modal.component';
import { RegistrationModalComponent } from 'src/app/events/registration/registration-modal.component';

@Component({
  selector: 'bxl-organization-bundles',
  templateUrl: 'organization-bundles.component.html',
})
export class OrganizationBundlesComponent implements OnInit {
  initialized = false;
  @Input() organization: OrganizationViewModel;
  @Input() element: PageElementViewModel;
  anyOnDemand: boolean;
  packageCategories: string[];
  activeCategory = '';

  registerMore: boolean;
  packages: RegistrationPackageViewModel[];

  constructor(private modalService: NgbModal, private user: UserService, private cmsService: ConferenceCMSService, private auth: AuthenticationService, private orgService: OrganizationService) {}

  ngOnInit(): void {
    this.fetchData();
  }



  fetchData() {
    this.cmsService.getOrganizationPackagesForRegistration(this.organization.id.toString()).subscribe((packages) => {
      this.packages = packages;
      this.packageCategories = this.packages
        .filter((x) => !x.onlyShowForGroups)
        .map((p) => p.category)
        .filter((value, index, self) => self.indexOf(value) === index);
      this.activeCategory = this.packageCategories[0];

    });
  }

  purchasePackage(pckg: RegistrationPackageViewModel) {
    if (this.auth.isLoggedIn()) {
      this.showPurchaseModal(pckg);
    } else {
      this.showLoginModal(pckg);
    }
  }

  showLoginModal(pckg: RegistrationPackageViewModel) {
    const modalRef = this.modalService.open(RegistrationModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.result.then(
      (result) => {
        this.auth.fetchUserProfile().subscribe((result) => {
          this.showPurchaseModal(pckg);
        });
      },
      (reason) => {}
    );
    return;
  }

  changeCategory(category: string) {
    this.activeCategory = category;
  }

  showPurchaseModal(pckg: RegistrationPackageViewModel) {
    const modalRef = this.modalService.open(PackagePurchaseModalComponent, { size: 'xl', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.packageId = pckg.id;
    modalRef.componentInstance.organization = this.organization;
    modalRef.result.then(
      (result) => {
        console.log('fetching data');

        this.fetchData();
      },
      (reason) => {}
    );
    return;
  }
}
